import cn from 'classnames';

import { FilterType } from '@webapp/account/src/resources/reports/filter';

import { Filter, Invisible } from '@webapp/common/assets/icons';
import { RemoveBtn } from '@webapp/common/assets/icons/remove';
import { setHtml } from '@webapp/common/lib/ui';
import { striptags } from '@webapp/common/lib/utils';

import css from './filter-line.css';

export const FilterLine: FC<{
    filterIndex: number;
    filter: any;
    onRemove: (filer: any, set: any) => void;
    loading: boolean;
}> = ({ filter, filterIndex, loading, onRemove }) => {
    return (
        <div className={cn(css.filter, { [css.loading]: loading })}>
            <div className={css.label}>
                <div className={css.num}>{filterIndex + 1}.</div>
                <span {...setHtml(striptags(filter.name))} />
            </div>
            {filter.sets?.map((set) => (
                <div className={css.line} key={`${set.id}-${set.name || set.text}`}>
                    {set.type === FilterType.EXCLUDE && <Invisible />}
                    {set.type === FilterType.INCLUDE && <Filter />}
                    <div
                        className={css.name}
                        {...setHtml(striptags(set.name || set.text))}
                        title={striptags(set.name || set.text)}
                    />
                    {!set.isDisabled && <RemoveBtn onClick={() => onRemove(filter, set)} />}
                </div>
            ))}
        </div>
    );
};
